import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Iomniclogo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0c0b23a9")

_pushScopeId("data-v-0c0b23a9")
const _hoisted_1 = {
  key: 1,
  style: {"width":"100px"},
  src: _imports_0
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("product")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("order")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("productQTY")
const _hoisted_5 = { class: "desktop-content" }
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Cancel")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_prism_editor = _resolveComponent("prism-editor")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _ctx.listDataPlatform,
      stripe: "",
      style: {"width":"100%"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "platform",
          label: "Platform"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Icon"
        }, {
          default: _withId((scope) => [
            (scope.row.platform !== 'iomnic')
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  style: {"width":"100px"},
                  src: _ctx.url + scope.row.image
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock("img", _hoisted_1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Inspect",
          width: "200px"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_dropdown, null, {
              dropdown: _withId(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_dropdown_item, {
                      onClick: ($event: any) => (_ctx.dialogOpenModal(scope.row, 'product'))
                    }, {
                      default: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: ($event: any) => (_ctx.dialogOpenModal(scope.row, 'order'))
                    }, {
                      default: _withId(() => [
                        _hoisted_3
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: ($event: any) => (_ctx.dialogOpenModal(scope.row, 'productQTY'))
                    }, {
                      default: _withId(() => [
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  icon: "el-icon-edit"
                })
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_el_dialog, {
        "destroy-on-close": "",
        title: _ctx.titleModal,
        modelValue: _ctx.dialogPlatform,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogPlatform = $event)),
        width: "100%",
        fullscreen: ""
      }, {
        footer: _withId(() => [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSave()))
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogPlatform = false))
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ]),
        default: _withId(() => [
          _createVNode(_component_el_form, {
            ref: "form",
            model: _ctx.formData
          }, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, { label: "Type" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.type = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Platform" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.platform,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.platform = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Name" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.name = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.formData.files.length)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "Old Content"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_table, {
                        data: _ctx.formData.files,
                        height: "250"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            fixed: "",
                            label: "Date Updated",
                            prop: "LastModified"
                          }),
                          _createVNode(_component_el_table_column, {
                            fixed: "",
                            label: "View"
                          }, {
                            default: _withId((scope) => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                icon: "el-icon-view",
                                onClick: ($event: any) => (_ctx.viewOldContent(scope.row))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, { label: "Content(Please Write code on VisualCode and copy it here)" }, {
                default: _withId(() => [
                  _createVNode(_component_prism_editor, {
                    class: "my-editor",
                    modelValue: _ctx.formData.content,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.content = $event)),
                    highlight: _ctx.highlighter,
                    "line-numbers": ""
                  }, null, 8, ["modelValue", "highlight"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ])
  ], 64))
})